<script lang="ts">
  export let closeOnBackgroundClick: boolean = true;
  export let fade = false;
  export let slide = false;
  export let centeredModal = false;
  export let show: boolean;
  export let fizzModal: boolean = false;
  export let fixedHeaderAndFooter: boolean = false;
  export let wide: boolean = false;
  export let size: string | null = null; //large, medium, small
  export let tiny: boolean = false;
  export let center: boolean = false;
  export let medium: boolean = false;
  export let height: number = null;
  export let overflow: string = "";
  export let overflowY: string = "";
  export let onClose: () => void = () => {};
  export let fullWidth: boolean = false;
  export let testId: string = "";

  function closeModal() {
    document.body.style.overflow = "";
    show = false;
    onClose();
  }

  function closeClick() {
    if (closeOnBackgroundClick) {
      closeModal();
    }
  }

  function closeKey(event) {
    if (closeOnBackgroundClick && event.which == 27) {
      closeModal();
    }
  }

  let customHeight = height ? `height: ${height}px;` : "";
  let customOverflow = "";
  if (overflow) {
    customOverflow = `overflow: ${overflow};`;
  } else if (overflowY) {
    customOverflow = `overflow-y: ${overflowY};`;
  }
</script>

<style lang="scss">
  .not-fizz-modal-tiny .fizz-modal-content {
    max-width: 500px;
  }
  .fullWidth {
    max-width: 100%;
  }

  .centered-modal {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;

    .fizz-modal-content {
      width: 100%;
    }
  }
</style>

<svelte:window on:keydown={closeKey} />

{#if show}
  {#if fizzModal}
    <div
      class={`fizz-modal
      ${medium ? "fizz-modal-medium" : ""}
      ${wide ? "fizz-modal-wide" : ""}
      ${size ? `fizz-modal-${size}` : ""}
      ${show ? "fizz-is-open" : ""}
      ${tiny ? "not-fizz-modal-tiny" : ""}`}
      id="fizzModal"
      on:click|stopPropagation
      class:fade
      class:slide
      class:centered-modal={centeredModal}
      data-testid={testId}
    >
      <div
        class="fizz-modal-overlay fizz-modal-toggle"
        data-modal="fizzModal"
        on:click={closeClick}
        id="fizz-modal-close"
        data-testid="close-modal"
      />
      <div
        class="fizz-modal-content"
        class:fizz-center-content={center}
        class:fixedHeaderAndFooter
        style="{customHeight} {customOverflow}"
        class:fullWidth
      >
        <slot />
      </div>
    </div>
  {:else}
    <div class="modal__background" class:fade class:slide on:click={closeClick}>
      <div class="modal__contents" style="{customHeight} {customOverflow}" on:click|stopPropagation>
        <slot />
      </div>
    </div>
  {/if}
{/if}
